import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jiraWorkManagementTrySampleProjectCtaHeading: {
		id: 'business-empty-view.jira-work-management-try-sample-project-cta-heading',
		defaultMessage: 'Looks like you haven’t tried business projects yet',
		description: 'Projects Directory empty state heading for Jira Core context',
	},
	jiraWorkManagementTrySampleProjectCtaDescriptionComplexspork: {
		id: 'business-empty-view.jira-work-management-try-sample-project-cta-description-complexspork',
		defaultMessage:
			'Did you know that business projects are included in your Jira license?Try a project with sample data to explore how business projects work seamlessly with software projects in Jira. When combined, they enable your cross-functional teams to collaborate better, together.',
		description: 'Projects Directory empty state description for Jira Core context',
	},
	jiraWorkManagementTrySampleProjectCtaButton: {
		id: 'business-empty-view.jira-work-management-try-sample-project-cta-button',
		defaultMessage: 'Try a sample project',
		description: 'Projects Directory empty state try sample project button prompt',
	},
	jiraWorkManagementIntroAnimationAltTextSpork: {
		id: 'business-empty-view.jira-work-management-intro-animation-alt-text-spork',
		defaultMessage: 'Jira business project introduction animation',
		description: 'Alt text for jwm-intro-animation-image component',
	},
});
